import React, { useEffect, useState } from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { Chip, TextField } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { TextInput } from '../../../FlowConfigurationInputs/TextInput/NewTextInput';
import VariablePicker from '../../../FlowConfigurationInputs/VariablePicker/VariablePicker';
/**
 * @Description This function lets you return component according to the name of the incoming action.
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Param       variableRenbder - variable render
 * @Returns     Component
 * @Author      ibrahim AKIN
 */
export default function LdapQuery({ action, variables, setOpenVariable }) {
  const { t } = useTranslation();
  const label = 'CONTENT.CONFIGURATION-FORM.ACTIVE-DIRECTORY.LDAP-QUERY.';
  const [value, setValue] = useState([]);

  useEffect(() => {
    if (!action.fields.attributes?.value) { action.fields.attributes = { value: '', isRequired: true }; }
    else { setValue(action.fields.attributes.value); }
  }, []);

  const handleChange = (e, newValue) => {
    action.fields.attributes.value = newValue;
    setValue(newValue);
  };
  return (
    <>
      <div className="form-element">
        {t(label + 'QUERY')}
        <TextInput action={action} inputName="query" variables={variables} setOpenVariable={setOpenVariable} isRequired fieldType="string"
          displayName={t(label + "QUERY")} />
        <small><em>(&(objectCategory=person)(objectClass=user)(sAMAccountName=test))</em></small>
      </div>
      <div className="form-element">
        {t(label + 'LDAP')}
        {action.fields.attributes?.value?.length < 1 &&
          <small style={{ color: '#D75E5E' }}>&nbsp;{t('CONTENT.TEXT-EDITOR.REQUIRED')}</small>
        }
        <Autocomplete multiple freeSolo size="small"
          onChange={handleChange} value={value}
          options={LDAPoptions}
          renderTags={(values, getTagProps) =>
            values.map((option, index) => (
              <Chip variant="outlined" label={option} {...getTagProps({ index })} />
            ))
          }
          renderInput={params => <TextField {...params} variant="outlined" />}
        />
      </div>
      <div className="form-element">
        {t('CONTENT.CONFIGURATION-FORM.DESKTOP-RECORDER.ASSIGN')}
        <VariablePicker action={action} inputName="output" variables={variables} setOpenVariable={setOpenVariable} filter="array" isRequired />
        <small><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'array' })}</em></small>
      </div>
    </>
  );
}
const LDAPoptions = [
  'userPrincipalName',
  'telephoneNumber',
  'sAMAccountName',
  'displayName',
  'department',
  'givenName',
  'company',
  'manager',
  'mobile',
  'title',
  'name',
  'sn'
];